import { render, staticRenderFns } from "./RegioColor.vue?vue&type=template&id=51ddbefc&"
import script from "./RegioColor.vue?vue&type=script&lang=js&"
export * from "./RegioColor.vue?vue&type=script&lang=js&"
import style0 from "./RegioColor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports